<template>
    <div class="app-layout">
        <NavBar
            style="position: fixed; top: 0; z-index: 999"
            :nav-items="navItems"
            :show-search="true"
            :show-lang="true"
        />
        <div class="bg">
            <div>
                <h1
                    :style="`font-size: ${this.$i18n.locale === 'zh' ? '54' : '36'}px;`"
                >
                    {{ $t("backTitle") }}
                </h1>
                <h2 v-if="this.$i18n.locale === 'zh'">{{ title.en }}</h2>
            </div>
        </div>
        <main class="app-main" style="min-height: 500px">
            <slot name="content">
                <router-view/>
            </slot>
        </main>
        <footer class="footer">
            Copyright &copy; 2025 天地一体频谱认知智能实验室
        </footer>
    </div>
</template>

<script>
import NavBar from "../components/NavBar";

export default {
    name: "AppLayout",
    components: {
        NavBar,
    },
    data() {
        return {
            title: {
                zh: "天地一体频谱认知智能实验室公开频谱数据集",
                en: "Space Sky-ground Spectrum Cognitive Intelligence Dataset",
            },
            navItems: [
                {name: "首页", en: "Home", subtitle: "", path: "/"},
                {
                    name: "频谱数据集",
                    en: "Spectrum Dataset",
                    subtitle: "Spectrum Dataset",
                    path: "/signal?type=1",
                },
                {
                    name: "信道数据集",
                    en: "Channel Dataset",
                    subtitle: "Channel Dataset",
                    path: "/signal?type=2",
                },
                {
                    name: "信号数据集",
                    en: "Signal Dataset",
                    subtitle: "Signal Dataset",
                    path: "/signal?type=3",
                },
            ],
        };
    },
    methods: {},
};
</script>

<style scoped>
.bg {
    text-align: center;
    border-bottom: 1px solid #e1e5eb;
    height: 400px;
    background: url("../assets/bg.png") no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}

h1 {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 54px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 0 auto;
}

h2 {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 36px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 0 auto;
}

.footer {
    width: 100%;
    height: 54px;
    background: #4169e2;
    border-radius: 0px 0px 0px 0px;
    text-align: center;
    color: white;
    line-height: 54px;
}
</style>
